<template>
  <div class="organization">
    <div class="menuCont">
      <my-tree ref="myTree"
               :treeData="treeData"
               :treeLoading="treeLoading"
               :treeToolBar="treeToolBar"
               :defaultProps="defaultProps"
               :departTotal="departTotal"
               :nodeKey="'id'"
               @handleAddTreeNode="handleAddTreeNode"
               @handleTreeNodeClick="handleTreeNodeClick"
               :default-expanded-keys="[1]"
               :btnName="btnName">
      </my-tree>
    </div>
    <div class="formCont">
      <el-form :model="addForm"
               ref="addForm"
               label-width="100px"
               :inline="true">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="部门名称"
                          :rules="[
                                { required: true, message: '请输入部门名称' }
                            ]"
                          prop="name">
              <el-input clearable
                        placeholder="请输入部门名称"
                        maxlength="30"
                        size="small"
                        v-model="addForm.name">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="上级部门">
               <span style="font-size:13px;position:relative;top:-1px">{{ addForm.parent_name }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="部门负责人"
                          :rules="[
                                { required: true, message: '请输入部门负责人' }
                            ]"
                          prop="manager">
              <el-select v-model="addForm.manager"
                         filterable
                         placeholder="请选择部门负责人"
                         size="small">
                <el-option v-for="item in staffList"
                           :key="item.id"
                           :label="item.name"
                           :value="item.id"
                           style="width:500px">
                </el-option>
              </el-select>
              <!-- </el-autocomplete> -->
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="部门职责">
              <el-input placeholder="请输入部门职责"
                        size="small"
                        type="textarea"
                        :rows="5"
                        v-model="addForm.desc">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="架构图">
              <imgUpload :images.sync="addForm.picture"
                         ref="uploadRef"
                         :width="'240'"
                         :height="'240'"
                         :limit="1"
                         :multiple="false"
                         :tb="2"
                         :pkid="nowClick.id"
                         :text="`*仅支持jpg,png等格式的图片，大小不超过5MB`" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer"
           class="dialog-footer"
           style="text-align:left;margin:80px 0 0 100px;">
        <el-button @click="commit"
                   type="primary"
                   size="small">保 存</el-button>
        <el-button @click="clear"
                   v-if="nowStatus"
                   size="small">清 空</el-button>
        <el-button @click="del"
                   type="danger"
                   v-else
                   size="small">删 除</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import * as api from "@/http/api.js";
import Tree from "@/comon/components/treeChange";
import { mapState } from "vuex";
import imgUpload from "@/comon/components/imgUpload";
import * as oaApi from "@/http/oaApi.js";
export default {
    data() {
        return {
            treeData: [],
            treeLoading: false,
            treeToolBar: true,
            defaultProps: {
                children: "child",
                label: "name",
            },
            defaultActive: 2,
            departTotal: 0,
            addForm: {
                picture: [],
                parent_id: "",
                name: "",
                desc: "",
                manager: "",
            },
            staffList: [],
            nowStatus: 0,
            nowClick: "",
            btnName: "创建部门",
        };
    },
    components: {
        "my-tree": Tree,
        imgUpload: imgUpload,
    },
    methods: {
        /**
         * 获取组织架构
         */
        depart(id) {
            api.depart({}, "get", id ? id : "").then((res) => {
                if (res) {
                    if (id) {
                        this.addForm = res.data;
                    } else {
                        this.treeData = res.data;
                        this.departTotal = res.total;
                        this.$nextTick(() => {
                            this.$refs.myTree.$refs.tree.setCurrentKey(
                                res.data[0].id
                            );
                        });
                        this.nowClick = res.data[0];
                        this.depart(this.nowClick.id);
                    }
                }
            });
        },
        // 树新增
        handleAddTreeNode(sth) {
            this.$refs["addForm"].clearValidate();
            this.$refs["addForm"].resetFields();
            this.addForm = {
                picture: [],
                parent_id: this.nowClick.id,
                parent_name: this.nowClick.name,
                name: "",
                desc: "",
                manager: "",
            };
            this.$refs.uploadRef.clear();
            this.nowStatus = 1;
            //   this.nowClick = null
        },
        // 节点点击
        handleTreeNodeClick(sth) {
            this.depart(sth.id);
            this.nowStatus = 0;
            this.nowClick = sth;
        },
        // 新增和修改提交
        commit() {
            if (this.nowStatus == 0) {
                this.addForm.id = this.nowClick.id;
            }
            api.depart(
                this.addForm,
                this.nowStatus == 0 ? "put" : "post",
                this.addForm.id ? this.addForm.id : ""
            ).then((res) => {
                if (res) {
                    if (res.code == 200) {
                        this.$message.success(
                            `${this.nowStatus == 0 ? "修改成功" : "新增成功"}`
                        );
                    }
                    this.treeData = res.data;
                    this.departTotal = res.total;
                    //   this.$nextTick(() => {
                    //     this.$refs.myTree.$refs.tree.setCurrentKey(res.data[0].id);
                    //   });
                    this.depart();
                }
            });
        },
        //删除提交
        del() {
            this.$confirm("确认删除该部门？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    api.depart({}, "delete", this.nowClick.id).then((res) => {
                        if (res) {
                            if (res.code == 200) {
                                this.$message.success("删除成功");
                            }
                            this.depart();
                        }
                    });
                })
                .catch(() => {
                    this.$message.info("未删除");
                });
        },
        /**
         * 清空
         */
        clear() {
            this.$refs.uploadRef.clear();
            this.addForm = {
                picture: [],
                parent_id: this.nowClick.id,
                parent_name: this.nowClick.name,
                name: "",
                desc: "",
                manager: "",
            };
        },
        staffSelect() {
            oaApi.select({}, "get").then(res => {
                if (res) {
                    this.staffList = res.data;
                }
            });
    },
    },
    created() {
        this.depart();
        this.staffSelect();
    },
    computed: {

    },
};
</script>
<style lang="scss">
.organization {
    width: 100%;
    min-height: 100%;
    background: #fff;
    display: flex;
    .menuCont {
        width: 250px;
        // border-right: 1px #eee solid;
        // padding: 0 20px;
        box-sizing: border-box;
        height: 100%;
    }
    .formCont {
        width: calc(100% - 250px);
        padding: 20px;
        border-left: 1px #ddd solid;
        .el-col-24 {
            text-align: left;
        }
        .el-form-item__content,
        .el-input {
            width: 500px;
        }
        .el-form-item {
            margin-bottom: 14px;
        }

        .avatar-uploader .el-upload:hover {
            border-color: $theme-color;
        }
        .avatar-uploader-icon {
            font-size: 28px;
            color: #8c939d;
            width: 178px;
            height: 178px;
            line-height: 178px;
            text-align: center;
        }
        .avatar {
            width: 178px;
            height: 178px;
            display: block;
        }
        .prompt {
            color: red;
            font-size: 8px;
            text-align: left;
        }
    }
}
</style>
